import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

class ModelLoader {
  constructor() {
    this.models = {};           // ��������ɼ��ص� GLTF
    this.animations = {};       // ����ÿ��ģ�͵Ķ�����������
    this.loadingPromises = {};  // �������ڼ��ص� Promise

    this.loader = new GLTFLoader();

    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('/draco/');        // ���ػ� CDN
    dracoLoader.setDecoderConfig({ type: 'wasm' });
    this.loader.setDRACOLoader(dracoLoader);
  }

  /** ���ز�����ģ�ͣ����� GLTF ���� */
  async loadModel(resolution, path) {
    if (this.models[resolution]) return this.models[resolution];

    if (this.loadingPromises[resolution]) {
      return this.loadingPromises[resolution];
    }

    const promise = this.loader.loadAsync(path)
      .then((gltf) => {
        this.models[resolution] = gltf; // �������� GLTF
        this.animations[resolution] = gltf.animations; // ���涯������
        delete this.loadingPromises[resolution];
        console.log(`? Model [${resolution}] loaded successfully, animations: ${gltf.animations?.length || 0}`);
        return gltf;
      })
      .catch((err) => {
        delete this.loadingPromises[resolution];
        console.error(`? Failed to load model [${resolution}]`, err);
        throw err;
      });

    this.loadingPromises[resolution] = promise;
    return promise;
  }

  /** ֱ�ӻ�ȡ Object3D ���������ã� */
  getModelClone(resolution) {
    const gltf = this.models[resolution];
    return gltf ? gltf.scene.clone(true) : null;
  }

  /** ��ȡģ�͵Ķ����������� */
  getAnimations(resolution) {
    return this.animations[resolution] || [];
  }

  /** Ԥ����ȫ��ģ�� */
  async preloadAllModels() {
    console.log('?? Start preloading all models...');
    await Promise.all([
        //this.loadModel('wh2','/models/wh2.glb'),
        //this.loadModel('sh13', '/models/sh13.glb'),
        //this.loadModel('BH_medium', '/models/BH_low.glb'),
        //this.loadModel('BH_high', '/models/BH_high.glb'),
        this.loadModel('sh15','https://cdn.bridgetunnelgroup.site/models/sh15.glb'),
        this.loadModel('sh14-p','https://cdn.bridgetunnelgroup.site/models/sh14-p.glb'),
        this.loadModel('wh19', 'https://cdn.bridgetunnelgroup.site/models/wh19.glb'),
        //this.loadModel('wh1', 'https://cdn.bridgetunnelgroup.site/models/wh1.glb'),
        //this.loadModel('wh11', 'https://cdn.bridgetunnelgroup.site/models/wh11.glb'),
        this.loadModel('wh20-p', 'https://cdn.bridgetunnelgroup.site/models/wh20-p.glb'),
        this.loadModel('SZ9','https://cdn.bridgetunnelgroup.site/models/SZ9.glb'),
        //this.loadModel('ZJL', '/models/ZJL.glb'),     // ͳһΪ glb ����
       // this.loadModel('YP_medium', '/models/YP_med.glb'),
        //this.loadModel('YP_high', '/models/compressed/YP_high.glb'),
      ]);
    console.log('? All models preloaded successfully');
  }
}

export const modelLoader = new ModelLoader();